export interface WechatMerchantTransferConfig {
  app_id?: string;
  mch_id?: string;
  package_info?: string;
}

declare global {
  interface Window {
    WeixinJSBridge?: {
      invoke: (
        name: string,
        params: Record<string, unknown>,
        callback: (result: { err_msg?: string; errMsg?: string }) => void
      ) => void;
    };
  }
}

export const invokeWechatMerchantTransfer = (config: WechatMerchantTransferConfig) =>
  new Promise<void>((resolve, reject) => {
    const run = () => {
      const bridge = window.WeixinJSBridge;
      if (!bridge) {
        reject(new Error("WeixinJSBridge is not ready"));
        return;
      }
      bridge.invoke(
        "requestMerchantTransfer",
        {
          appId: config.app_id,
          mchId: config.mch_id,
          package: config.package_info,
        },
        (result) => {
          const message = result.err_msg || result.errMsg || "";
          if (message.includes(":ok")) {
            resolve();
            return;
          }
          reject(new Error(message || "requestMerchantTransfer failed"));
        }
      );
    };

    if (window.WeixinJSBridge) {
      run();
      return;
    }
    document.addEventListener("WeixinJSBridgeReady", run, { once: true });
  });
